var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"flex mb-3"},[_c('font-awesome-icon',{staticClass:"mr-1 mt-1",class:_vm.isDefault ? 'text-white' : 'text-primary-color',attrs:{"icon":['far', 'check-circle']}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.feature))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }